import styled from 'styled-components';
// import { gridLayout } from './CustomReportTab';
import { useEffect, useState } from 'react';
import { DarkButton } from 'components/style/Global';
import { useSaveCustomReportKPI } from './CustomReportsHooks/useCustomReportsKPI';
import { GridLayout } from 'API';
import { useCustomReportContext } from 'context/CustomReportContext';
import { useGetCustomReportPublishedData, useSaveNewSectionItem } from './CustomReportsHooks/useCustomReportsGrid';
import { removeTypename } from 'methods/removeTypename';
import DeleteConfirmationModal from 'components/DeleteConfirmationModall';
import { createPortal } from 'react-dom';

export const CustomReportKPIStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: left;
  width: 100%;
  height: 100%;
  overflow: hidden;
  gap: 0.1vw;
  padding: 0.4vw 0 0vw 0.6vw;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.placeholderBackground} 0%,
    ${({ theme }) => theme.placeholderBackground}F8 100%
  );
  border-radius: 8px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, ${({ theme }) => theme.border}40 50%, transparent 100%);
  }

  .action-buttons-container {
    display: flex;
    justify-content: end;
    gap: 0.6vw;
    margin-top: 1vw;
  }
  &:hover {
    .edit-btns {
      display: flex;
      flex-direction: row;
      gap: 5px;
      background-color: transparent;
    }
  }

  .edit-btns {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
    .edit-btn {
      /* pointer-events: none; */
      font-weight: 300;
      box-shadow:
        0 2px 8px rgba(0, 0, 0, 0.1),
        0 1px 3px rgba(0, 0, 0, 0.08);
      border-radius: 50%;
      cursor: pointer;
      padding: 6px;
      transition: all 0.2s ease;
      background: ${({ theme }) => theme.c50};
      color: ${({ theme }) => theme.brand};
      border: 1px solid ${({ theme }) => theme.c100}40;

      &:hover {
        outline: 1px solid ${({ theme }) => theme.c200};
        box-shadow:
          0 3px 12px rgba(0, 0, 0, 0.15),
          0 2px 6px rgba(0, 0, 0, 0.1);
        transform: scale(1.05);
        background: ${({ theme }) => theme.c100};
      }
    }
  }
  .title {
    font-weight: normal;
    font-size: 14px;
  }
  .subtitle {
    font-weight: normal;
    font-size: 10px;
    font-family: 'fontRegular';
    margin-bottom: 5px;
  }
  .value {
    font-size: 28px;
    color: ${({ theme }) => theme.brand};
    font-family: 'FontBold';
  }

  .editDataForm {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5vw;
    input,
    select {
      width: 100%;
    }
  }
  .testbtn {
  }
`;

type Props = {
  layoutItem: GridLayout;
  modal?: boolean;
  handleModalType: (item: GridLayout | null, type: string | null) => void;
  deleteItem?: (sectionID: string, sectionItemID: string) => void;
  sectionID: string | null | undefined;
  fetchKPI: (sectionItemID: string) => Promise<KPIvalues | null>;
  kpiValue: KPIvalues | null;
  onKpiSaved?: (sectionItemID: string, kpi: KPIvalues) => void;
};

export type KPIvalues = {
  labelTitle: string;
  labelSubtitle: string;
  valueFormat: string;
  value: number;
};

const CustomReportKPI = (props: Props) => {
  const { layoutItem, modal, handleModalType, deleteItem, sectionID, kpiValue, fetchKPI, onKpiSaved } = props;
  const {
    safeSectionLayoutUpdate,
    sectionLayoutState,
    activeCustomReport,
    publishPlaceholderObject,
    setPublishPlaceholderObject,
  } = useCustomReportContext();
  const userIsAuthorized = activeCustomReport?.authorized;
  const [kpiValues, setKpiValues] = useState<KPIvalues>(
    kpiValue ??
      ({
        labelTitle: '',
        labelSubtitle: '',
        valueFormat: 'number',
        value: 0,
      } as KPIvalues),
  );
  const KPIformatOptions = ['number', 'percentage'];
  const [saveCustomReportKPI] = useSaveCustomReportKPI();
  const [saveNewSectionItem] = useSaveNewSectionItem();
  const [localKpi, setLocalKpi] = useState<KPIvalues>(
    kpiValue ?? {
      labelTitle: '',
      labelSubtitle: '',
      valueFormat: 'number',
      value: 0,
    },
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    if (modal)
      setLocalKpi(
        kpiValue ?? {
          labelTitle: '',
          labelSubtitle: '',
          valueFormat: 'number',
          value: 0,
        },
      );
  }, [modal, kpiValue]);

  const [publishedData] = useGetCustomReportPublishedData();

  useEffect(() => {
    if (!kpiValue && layoutItem.SectionItemID && fetchKPI) {
      if (activeCustomReport?.authorized) {
        fetchKPI(layoutItem.SectionItemID);
      } else {
        publishedData(layoutItem.SectionItemID).then((data) => {
          if (data) {
            fetchKPI(layoutItem.SectionItemID as string);
          } else {
            safeSectionLayoutUpdate((prev) => {
              return prev.map((section) => {
                if (section.SectionID === sectionID) {
                  return {
                    ...section,
                    SectionElements: section.SectionElements?.filter(
                      (item) => item?.SectionItemID !== layoutItem.SectionItemID,
                    ),
                  };
                }
                return section;
              });
            });
          }
        });
      }
    }
  }, [
    layoutItem.SectionItemID,
    kpiValue,
    fetchKPI,
    activeCustomReport?.authorized,
    publishedData,
    safeSectionLayoutUpdate,
    sectionID,
  ]);

  const kpiToShow = modal ? localKpi : kpiValue;
  useEffect(() => {
    if (kpiToShow && layoutItem.SectionItemID) {
      const placeholdersObject = {
        position: String(layoutItem.SectionItemID),
        outputlocation: kpiToShow.labelTitle,
        outputlocationTotal: kpiToShow.labelSubtitle,
        metrics: {
          chartType: kpiToShow.valueFormat,
          metric: 'kpi',
          axis: 1,
        },
      };
      const IdtoUse = layoutItem.SectionItemID;

      // Use functional setState to avoid reading publishPlaceholderObject
      setPublishPlaceholderObject((prev) => ({
        ...prev,
        [IdtoUse || '']: {
          ...prev[IdtoUse || ''],
          ...placeholdersObject,
        },
      }));
    }
  }, [kpiToShow, layoutItem.SectionItemID, sectionID, setPublishPlaceholderObject]);

  const handleSave = async () => {
    const updateAndClose = (id: string) => {
      const updatedSectionLayoutState = sectionLayoutState.map((section) => {
        return {
          ...section,
          SectionElements: section.SectionElements?.map((el) => {
            if (el?.SectionItemID === id || el?.GridPosition?.i === layoutItem.GridPosition?.i) {
              return {
                ...el,
                Position: layoutItem.Position,
                SectionItemID: id,
                Open: false,
                __typename: 'GridLayout',
              } as GridLayout;
            }
            return el;
          }),
        };
      });
      if (onKpiSaved) {
        onKpiSaved(id, kpiValues);
      }
      safeSectionLayoutUpdate(() => updatedSectionLayoutState);
    };

    const cleanedLayoutItem = removeTypename(layoutItem);
    if (!layoutItem.SectionItemID) {
      // THIS SAVES VALUE TO THE DB
      delete cleanedLayoutItem.SectionItemID;
      delete cleanedLayoutItem.Open;
      await saveNewSectionItem(sectionID as string, cleanedLayoutItem).then((res) => {
        if (res.status === 200) {
          saveCustomReportKPI(res.id as string, kpiValues).then((result) => {
            if (result === 'success') {
              console.log('success');
              updateAndClose(res.id as string);
            } else {
              console.log('error', res);
            }
          });
        } else {
          alert(res.message);
        }
      });
    } else {
      saveCustomReportKPI(cleanedLayoutItem.SectionItemID as string, kpiValues).then((res) => {
        if (res === 'success') {
          console.log('success');
          updateAndClose(cleanedLayoutItem.SectionItemID as string);
        } else {
          console.log('error', res);
        }
      });
    }
  };

  return (
    <CustomReportKPIStyled>
      {!modal && userIsAuthorized && (
        <div className="edit-btns">
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleModalType && handleModalType(layoutItem, 'kpi');
            }}
            className="edit-btn icon material-symbols-outlined"
          >
            edit
          </div>
          <div className="edit-btn icon material-symbols-outlined" onClick={() => setShowDeleteModal(true)}>
            delete
          </div>
        </div>
      )}
      {modal ? (
        <div className="editDataForm">
          <h1>
            Label Title
            <input
              defaultValue={kpiToShow?.labelTitle}
              onChange={(e) => setKpiValues((prev: KPIvalues) => ({ ...prev, labelTitle: e.target.value }))}
              type="text"
            />
          </h1>
          <h1>
            Label Subtitle
            <input
              defaultValue={kpiToShow?.labelSubtitle}
              onChange={(e) => setKpiValues((prev: KPIvalues) => ({ ...prev, labelSubtitle: e.target.value }))}
              type="text"
            />
          </h1>
          <h1>
            Value Format
            <select
              defaultValue={kpiToShow?.valueFormat === null ? 'number' : kpiToShow?.valueFormat}
              onChange={(e) => setKpiValues((prev: KPIvalues) => ({ ...prev, valueFormat: e.target.value }))}
            >
              {KPIformatOptions.map((e) => (
                <option key={e} value={e}>
                  {e}
                </option>
              ))}
            </select>
          </h1>

          <h1>
            Value
            <input
              //   defaultValue={val === null ? 'NaN' : val}
              defaultValue={kpiToShow?.value ?? ''}
              type="number"
              onChange={(e) => setKpiValues((prev: KPIvalues) => ({ ...prev, value: parseFloat(e.target.value) }))}
            />{' '}
          </h1>
          <div></div>
          <div className="action-buttons-container">
            <button
              onClick={() => {
                console.log('KILL');
                handleModalType && handleModalType(null, null);
              }}
              className="action-button"
            >
              Cancel
            </button>
            <DarkButton
              onClick={() => {
                handleSave();
              }}
              className="action-button"
            >
              Save
            </DarkButton>
          </div>
        </div>
      ) : (
        <>
          <h1 className="title">{kpiToShow?.labelTitle}</h1>
          {kpiToShow?.labelSubtitle ? (
            <h2 className="subtitle">{kpiToShow?.labelSubtitle}</h2>
          ) : (
            <h2 style={{ color: 'transparent' }} className="subtitle">
              ..
            </h2>
          )}
          <div className="value">
            {kpiToShow?.value && Intl.NumberFormat('en-DK', { notation: 'compact' }).format(kpiToShow?.value)}
            {kpiToShow?.valueFormat === 'percentage' && '%'}
          </div>
        </>
      )}

      {showDeleteModal &&
        createPortal(
          <DeleteConfirmationModal
            handleDeleteConfirmationModal={(confirmed) => {
              if (confirmed) {
                deleteItem && deleteItem(sectionID as string, layoutItem.SectionItemID as string);
              }
              setShowDeleteModal(false);
            }}
            modalObject={{
              title: 'Delete KPI Element',
              message: 'Are you sure you want to delete this KPI element? This action cannot be undone.',
              mainButton: 'Delete',
              secondaryButton: 'Cancel',
            }}
          />,
          document.body,
        )}
    </CustomReportKPIStyled>
  );
};

export default CustomReportKPI;
